import React, { useEffect } from 'react';
import {
  Container,
} from 'reactstrap';
import Swiper from 'swiper';


const images = [
  '../../images/home/testimonials/hugh.webp',
  '../../images/home/testimonials/cheryl.webp',
  '../../images/home/testimonials/joe.webp'
];

const items = [
  {
    id: 0,
    name: 'Hugh Molyneux',
    jobTitle: 'President / Refined Risk',
    image: 'hugh',
    quote:
        "There are a lot of cloud management companies out there that charge a flat fee, and as a smaller company, that just wasn't in our budget. The Cloudnexa assessment gave us many options for high availability and for our backup needs.",
  },
  {
    id: 1,
    name: 'Cheryl Lasse',
    jobTitle: 'Managing Partner / SkillDirector',
    image: 'cheryl',
    quote:
        'Cloudnexa helped us translate our business requirements into the specific AWS features and services we would need. AWS allows us to be agile and consistently deliver new enhancements to the market quickly. AWS is Nirvana and Cloudnexa is the Sherpa that gets you there.',
  },
  {
    id: 2,
    name: 'Joe Stern',
    jobTitle: 'UX Architect',
    image: 'joe',
    quote:
        'Orases is a Maryland based web development company providing custom software, website and application development services. In addition to Cloudnexa providing an AWS infrastructure HIPAA compliant environment, Orases leverages Cloudnexa’s powerful vNOC management platform for its simplification of handling all AWS accounts.',
  },
];

const Testimonials = () => {
  useEffect(() => {
    new Swiper('.Testimonials__wrap', {
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.Testimonials__next',
        prevEl: '.Testimonials__prev',
      },
    });
  }, [])

  const elements = items.map((item, index) => {
    return (
        <div className="swiper-slide" key={item.id}>
          <div className="TestimonialItem">
            <img src={images[index]} alt={item.name} className="TestimonialItem__img" width="100" height="100" />
            <div className="TestimonialItem__box">
              <div className="TestimonialItem__name">{item.name}</div>
              <div className="TestimonialItem__title">{item.jobTitle}</div>
              <div className="TestimonialItem__quote">{item.quote}</div>
            </div>
          </div>
        </div>
    )
  })

  return (
      <section className="Testimonials">
        <Container>
          <h3 className="Testimonials__title">
            <span className="text-blue">Learn From</span> The Best
          </h3>

          <div className="Testimonials__wrap swiper-container">
            <div className="swiper-wrapper">
              {elements}
            </div>

            <div className="swiper-pagination"></div>
            <div className="Testimonials__prev swiper-button-prev"></div>
            <div className="Testimonials__next swiper-button-next"></div>
          </div>
        </Container>
      </section>
  );
};

export default Testimonials;
